import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled(Paper)`
    display: flex;
    flex: 1;
    padding: 16px;
    flex-direction: column;
`;

export const CardTitle = styled.h2`
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  color: #031795;
`;

export const InputContainer = styled.div`
    display: grid;
    width: 100%;
    margin-top: 16px;
`;

export const AccessCheckboxList = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    overflow: auto;
    margin-top: 16px;
`;
